import { ISettingsState, initialSettingsState } from './settings-state';
import { IEntitiesState } from '../shared/entities/entities-state';
import { createNamedWrapperReducer, isActionRelated } from '@core/utils/state';
import {
    EMPLOYEES_SUGGESTIONS_FETCH,
    SETTINGS_FETCH,
    SETTINGS_FETCHING_SET,
    SETTINGS_SET
} from '../action-types';
import { reducer as listReducer } from '../shared/list/reducer';
import {
    GROUP_EMPLOYEE_SUGGESTIONS
} from '../state-groups';

export function reducer(
    state: ISettingsState = initialSettingsState(),
    action: any,
    entitySlice: IEntitiesState): ISettingsState {        
      
    switch (action.type) {

        case SETTINGS_SET:
            return {
                ...state,
                settings: {
                    ...action.payload.settings
                }
            };

        case SETTINGS_FETCH:
            return {
                ...state,
                isFetching: true
            };

        case SETTINGS_FETCHING_SET:
            return {
                ...state,
                isFetching: action.payload
            };

        case EMPLOYEES_SUGGESTIONS_FETCH:
            return {
                ...state,
                suggestions: {
                    ...state.suggestions, isFetching: true
                }
            };

        default:
            let nextState: ISettingsState = state;

            if (isActionRelated(action, [
                GROUP_EMPLOYEE_SUGGESTIONS
            ])) {
                nextState = {
                    ...state,
                    suggestions: createNamedWrapperReducer(
                        listReducer,
                        GROUP_EMPLOYEE_SUGGESTIONS
                    )(state.suggestions, action, entitySlice.entities)
                };
            }

            return nextState;
    }
}
